import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useRouter } from "next/router";

const LoadmoreOrLessText = (props) => {
  const router = useRouter();
  const { text } = props;
  const [clamped, setClamped] = useState(true);
  const [showButton, setShowButton] = useState(true);
  const containerRef = useRef(null);
  const handleClick = () => setClamped(!clamped);

  useEffect(() => {
    const hasClamping = (el) => {
      const { clientHeight, scrollHeight } = el;
      return clientHeight !== scrollHeight;
    };

    const checkButtonAvailability = () => {
      if (containerRef.current) {
        // Save current state to reapply later if necessary.
        const hadClampClass = containerRef.current.classList.contains("clamp");
        // Make sure that CSS clamping is applied if aplicable.
        if (!hadClampClass) containerRef.current.classList.add("clamp");
        // Check for clamping and show or hide button accordingly.
        setShowButton(hasClamping(containerRef.current));
        // Sync clamping with local state.
        if (!hadClampClass) containerRef.current.classList.remove("clamp");
      }
    };

    checkButtonAvailability();
    window.addEventListener("resize", checkButtonAvailability);

    return () => {
      window.removeEventListener("resize", checkButtonAvailability);
    };
  }, [containerRef]);
  //============== reset ClampValue on page load/refresh =========
  useEffect(() => {
    const hasClamping = (el) => {
      const { clientHeight, scrollHeight } = el;
      return clientHeight !== scrollHeight;
    };

    const checkButtonAvailability = () => {
      if (containerRef.current) {
        setClamped(true);
        const hadClampClass = containerRef.current.classList.contains("clamp");
        if (!hadClampClass) containerRef.current.classList.add("clamp");
        setShowButton(hasClamping(containerRef.current));
        if (!hadClampClass) containerRef.current.classList.remove("clamp");
      }
    };

    checkButtonAvailability();

    router.events.on("routeChangeStart", checkButtonAvailability);
    router.events.on("routeChangeComplete", checkButtonAvailability);
    router.events.on("routeChangeError", checkButtonAvailability);

    return () => {
      router.events.off("routeChangeStart", checkButtonAvailability);
      router.events.off("routeChangeComplete", checkButtonAvailability);
      router.events.off("routeChangeError", checkButtonAvailability);
    };
  }, [containerRef, router.events]);

  return (
    <>
      <div ref={containerRef} className={clamped ? "clamp" : "noclamp"} >
        {text}
      </div>
      {showButton && (
        <button className="loadmore" onClick={handleClick}>
          Read {clamped ? "more" : "less"}{" "}
          <FontAwesomeIcon
            icon={clamped ? faArrowDown : faArrowUp}
            style={{ marginLeft: "5px", fontSize: "15px" }}
          />
        </button>
      )}
    </>
  );
};

export default LoadmoreOrLessText;